import { jsx as r, jsxs as c } from "react/jsx-runtime";
import { useTranslation as d } from "react-i18next";
import a from "markdown-to-jsx";
import o from "@mui/material/Box";
import f from "@mui/material/Container";
import m from "@mui/material/Grid";
import l from "@mui/material/Typography";
import { makeStyles as x } from "tss-react/mui";
import { manageSmoothScrolling as g } from "../../../../../utils/index.js";
import y from "../../../../common/Button/Button.js";
import N from "./OurDrivers.style.js";
const v = x()(N), S = ({ data: e }) => {
  var t;
  const { classes: s } = v(), { t: p } = d(), i = (e == null ? void 0 : e.heading) ?? "", n = (e == null ? void 0 : e.subHeading) ?? "", u = ((t = e == null ? void 0 : e.img) == null ? void 0 : t.url) ?? "", h = () => {
    g("#reservationForm");
  };
  return /* @__PURE__ */ r(o, { py: { xs: 4, md: 15 }, className: s.wrapper, children: /* @__PURE__ */ r(f, { children: /* @__PURE__ */ c(m, { container: !0, columnSpacing: 12, className: s.row, children: [
    /* @__PURE__ */ r(
      m,
      {
        item: !0,
        xs: 12,
        sm: 12,
        md: 6,
        order: { xs: 2, sm: 2, md: 1 },
        py: { xs: 2, sm: 0 },
        children: /* @__PURE__ */ c(o, { className: s.content, children: [
          i && /* @__PURE__ */ r(
            l,
            {
              variant: "h1",
              mb: { xs: 2 },
              className: s.title,
              children: i
            }
          ),
          n && /* @__PURE__ */ r(
            l,
            {
              variant: "h4",
              mb: { xs: 4 },
              className: s.description,
              children: /* @__PURE__ */ r(a, { children: n })
            }
          ),
          /* @__PURE__ */ r(
            y,
            {
              fullWidth: !0,
              dataTestid: "ourDriversQuoteBtn",
              className: s.quoteBtn,
              onClick: h,
              children: p("get_a_quote!")
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ r(
      m,
      {
        item: !0,
        xs: 12,
        sm: 12,
        md: 6,
        order: { xs: 1, sm: 1, md: 2 },
        py: { xs: 2, sm: 0 },
        children: /* @__PURE__ */ r(o, { className: s.imgWrapper, children: /* @__PURE__ */ r("img", { src: u, alt: "Why Rent Lumi Img" }) })
      }
    )
  ] }) }) });
}, R = S;
export {
  R as default
};
